import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { UserRole } from '../models/models'

/**
 * Re-reads roles from the Cognito JWT on every navigation rather than
 * relying on the mutable in-memory UserService.currentUser. This prevents
 * a client-side role escalation where any code (Angular DevTools, browser
 * console) could overwrite currentUser.roles and bypass all route guards.
 *
 * Each call performs a local Amplify fetchAuthSession() (no network request
 * unless the access token needs silent refresh), so the overhead is minimal.
 * authGuard always runs first and verifies the session is valid before this
 * guard is reached.
 */
export function roleGuard(role: UserRole): CanActivateFn {
  return async () => {
    const auth = inject(AuthService)
    const router = inject(Router)
    const cognitoUser = await auth.resolveCurrentUser()
    if (cognitoUser?.roles.includes(role)) return true
    return router.createUrlTree([''])
  }
}
